import { useId, type ComponentProps, type ReactNode } from "react";
import { cn } from "@/lib/cn";

export function Input({ className, invalid, ...props }: ComponentProps<"input"> & { invalid?: boolean }) {
  return <input className={cn("cs-input", className)} aria-invalid={invalid || undefined} {...props} />;
}

interface FieldProps extends ComponentProps<"input"> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  fieldClassName?: string;
}

/** 带标签 / 提示 / 错误的输入框（对应设计系统 Input）。 */
export function Field({ label, hint, error, id, fieldClassName, className, ...props }: FieldProps) {
  const auto = useId();
  const fid = id ?? auto;
  return (
    <div className={cn("cs-field", fieldClassName)}>
      {label ? (
        <label className="cs-label" htmlFor={fid}>
          {label}
        </label>
      ) : null}
      <Input id={fid} invalid={!!error} className={className} aria-describedby={error || hint ? `${fid}-hint` : undefined} {...props} />
      {error ? (
        <div id={`${fid}-hint`} className="cs-hint cs-hint-error">
          {error}
        </div>
      ) : hint ? (
        <div id={`${fid}-hint`} className="cs-hint">
          {hint}
        </div>
      ) : null}
    </div>
  );
}

export function Label({ className, ...props }: ComponentProps<"label">) {
  return <label className={cn("cs-label", className)} {...props} />;
}
